/* Vindumi Startseite neu: Weinscore-Pille auf den Kacheln öffnet dieselbe Erklärung wie auf den Produktseiten. 29.09.2026 */
(function () {
  'use strict';
  if (window.__vdsKacheln) return;
  window.__vdsKacheln = true;
  var pop, bg, zuletzt;
  function bau() {
    bg = document.createElement('div');
    bg.className = 'vds-ws-bg'; bg.hidden = true;
    pop = document.createElement('div');
    pop.className = 'vds-ws-pop'; pop.hidden = true;
    pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-modal', 'true'); pop.setAttribute('aria-labelledby', 'vds-ws-titel');
    pop.innerHTML = '<button type="button" class="vds-ws-pop__zu" aria-label="Schließen">&times;</button>' +
      '<p class="vds-ws-pop__titel" id="vds-ws-titel">Vindumi Weinscore</p>' +
      '<p>Unsere eigene Bewertung. Sie spiegelt wider, wie sehr uns dieser Wein im Verhältnis zu Charakter, Trinkfreude und Preis überzeugt hat. Keine Maschinenbewertung, sondern unsere Empfehlung aus dem Verkostungsteam.</p>' +
      '<p>Dieser Wein: <strong data-wert></strong></p>';
    document.body.appendChild(bg); document.body.appendChild(pop);
    bg.addEventListener('click', zu);
    pop.querySelector('.vds-ws-pop__zu').addEventListener('click', zu);
  }
  function auf(knopf) {
    if (!pop) bau();
    pop.querySelector('[data-wert]').textContent = knopf.getAttribute('data-score') + '/100';
    bg.hidden = false; pop.hidden = false;
    zuletzt = knopf; knopf.setAttribute('aria-expanded', 'true');
    pop.querySelector('.vds-ws-pop__zu').focus();
  }
  function zu() {
    if (!pop || pop.hidden) return;
    pop.hidden = true; bg.hidden = true;
    if (zuletzt) { zuletzt.setAttribute('aria-expanded', 'false'); zuletzt.focus(); }
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest('.vds [data-score]'); if (!k) return;
    e.preventDefault(); e.stopPropagation(); auf(k);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zu(); });
  /* Kurzer Stepper auf den Kacheln: vds-startseite.js schreibt "2 im Warenkorb", hier bleibt nur die Zahl */
  function kurz(sp) { var n = parseInt(sp.textContent, 10); if (!isNaN(n) && sp.textContent !== String(n)) sp.textContent = String(n); }
  function beobachte() {
    document.querySelectorAll('.vds .stepper[data-kurz] span').forEach(function (sp) {
      kurz(sp);
      new MutationObserver(function () { kurz(sp); }).observe(sp, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachte); else beobachte();
})();
